import { applyPolyfills, defineCustomElements } from "@product/scmp-menu-component/loader";
import type { FunctionComponent } from "react";
import { useEffect, useMemo, useState } from "react";

import type { AppBarVariant } from "~/components/app-bar/types";
import { HamburgerMenuWrapper } from "~/components/hamburger-menu/hamburger-menu-wrapper";

import { HamburgerMenuContent } from "./hamburger-menu-content";

type Props = {
  variant?: AppBarVariant;
};

export const HamburgerMenuDefault: FunctionComponent<Props> = ({ variant }) => {
  const [isCustomElementsInitialized, setIsCustomElementsInitialized] = useState(false);

  useEffect(() => {
    void applyPolyfills().then(() => {
      void defineCustomElements().then(() => {
        setIsCustomElementsInitialized(true);
      });
    });
  }, []);

  const anchor = useMemo(() => {
    switch (variant) {
      case "scmp/home":
      case "scmp/home-slim":
        return "left";
      default:
        return "right";
    }
  }, [variant]);

  return isCustomElementsInitialized ? (
    <HamburgerMenuWrapper anchor={anchor}>
      {({ closeClickedHandler, closeMenu }) => (
        <HamburgerMenuContent closeClickedHandler={closeClickedHandler} closeMenu={closeMenu} />
      )}
    </HamburgerMenuWrapper>
  ) : null;
};

HamburgerMenuDefault.displayName = "HamburgerMenuDefault";
